import { NavLink } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";

export interface Breadcrumb {
  link: string;
  text: string;
}

export function Breadcrumb(props: Breadcrumb) {
  return (
    <Fragment key={props.link}>
      <NavLink to={props.link}>
        <p
          title={props.text}
          className="text-md text-persian-990 truncate hover:text-persian-900"
        >
          {props.text.slice(0, Math.min(props.text.length, 30))}
          {props.text.length > 30 ? "..." : ""}
        </p>
      </NavLink>
    </Fragment>
  );
}

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  pageTitle: string;
}

export function Breadcrumbs(props: BreadcrumbsProps) {
  return (
    <div>
      <div className="flex items-center gap-x-1.5">
        {props.breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={breadcrumb.link}>
            <Breadcrumb key={breadcrumb.link} {...breadcrumb} />
            <p className="font-light text-persian-990">/</p>
          </Fragment>
        ))}
      </div>
      <p className="text-sm mt-0 text-persian-990 font-semibold">
        {props.pageTitle.slice(0, Math.min(props.pageTitle.length, 120))}
        {props.pageTitle.length > 120 ? "..." : ""}
      </p>
    </div>
  );
}
